import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as cts from '../../../constants/ui/svg';
import { Empty, Input, Modal, Tooltip } from 'antd';
import { IMAGE_BASE_URL } from '../../../constants';
import beside from '../../../assets/images/beside.png';
import slide from '../../../assets/images/slide.png';
import imgPreview1 from '../../../assets/images/imgPreview1.png';
import imgPreview2 from '../../../assets/images/imgPreview2.png';
import { useAppSelector } from '../../../hooks';
import ModalTextEditor from './ModalTextEditor';
import { NoteStyleConfig, Shop } from 'models';
import { generateImage, rgbToHex, useDebounceFn } from 'helpers/functionHelper';
import ShopNoLogo from '../../../assets/images/no-logo.png';
type OrderByRankingItem = {
  id: number;
  layout_ranking: number;
  name: string;
  shop_id: number;
  status: number;
  value: number;
  created_at: string;
  updated_at: string;
};

type SelectedItem = {
  created_at: string;
  description: string | null;
  id: number;
  link: string;
  order_by: number;
  shop_id: number;
  title: string | null;
  type: number;
  updated_at: string;
};
type SliderItem = {
  created_at: string;
  id?: number;
  images_slider: null | SelectedItem;
  images_slider_id: null | number;
  order_by: number;
  order_by_ranking: null | OrderByRankingItem;
  order_by_ranking_id: null | number;
  second_change: number | string;
  layout_ranking: null | number;
  shop_id: number;
  type: number;
  name: string;
  updated_at: string;
  select_shop_id?: number;
  select_shop?: Shop;
  isNewMedia: boolean;
  isNewRankingOfShopMaster: boolean;
  is_group_ranking: boolean;
  layout_quantity_user_slider_ranking: number;
  quantity_user_slider_app_rank: number | string;
  order_by_image_slider_ranking_id: number;
  // Note data for Beside layout (0)
  note_beside?: string | null;
  font_beside?: string | null;
  font_size_beside?: number | null;
  color_beside?: string | null;
  stroke_color_beside?: string | null;
  stroke_width_beside?: number | null;
  // Note data for Slider layout (1)
  note_slider?: string | null;
  font_slider?: string | null;
  font_size_slider?: number | null;
  color_slider?: string | null;
  stroke_color_slider?: string | null;
  stroke_width_slider?: number | null;
  ranking_list_shop?: Array<{ select_shop_id?: number; id?: number }>;
  delete_ranking_list_shop_ids?: Array<number>;
};

type RankingChildItem = {
  id: number;
  shop_id: number;
  name: string;
  value: number;
  status: number;
  layout_ranking: number;
  created_at: string;
  updated_at: string;
  quantity_user_app_rank: number;
  layout_quantity_user_ranking: number;
};
type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  data: any;
  dataTab1: any;
  setImageSliderState: React.Dispatch<React.SetStateAction<any>>;
  imageSliderState: Array<SliderItem>;
  selectItem: any;
};
// type RankingDisplay = 'onlyTop10' | 'otherThan10';
type RankingDisplay = null | 0 | 1; //0 & null: onlyTop10, 1: otherThan10
function ModalSelectItemProgram({
  open,
  setOpen,
  data,
  dataTab1,
  setImageSliderState,
  imageSliderState,
  selectItem,
}: Props) {
  const { t } = useTranslation();

  const modalSettingProgramTabs = [
    {
      title: 'リスト',
      tab: 1,
    },
    {
      title: t('IMAGE'),
      tab: 2,
    },
    {
      title: t('MOVIE'),
      tab: 3,
    },
  ];

  const selectShop = useAppSelector((state) => state.shopList.selectShop);
  const masterInfo = useAppSelector((state) => state.auth.masterInfo);
  const listShop = useAppSelector((state) => state.shopList.listShop);

  const isMaster = Boolean(masterInfo.active && !selectShop.id);

  const [tempSelectedItemsTab, setTempSelectedItemsTab] = useState<Array<SliderItem>>([]);
  const [tab, setTab] = useState(1);
  const [itemRanking, setItemRanking] = useState<RankingChildItem | null>(null);
  const [selectedSlideMedia, setSelectedSlideMedia] = useState<Array<any>>([]);
  const [openChooseLayout, setOpenChooseLayout] = useState(false);
  const [isOpenModalEditText, setIsOpenModalEditText] = useState(false);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [currentLayoutForEdit, setCurrentLayoutForEdit] = useState<number | null>(null);
  const [selectShopOnChooseRankingSetting, setSelectShopOnChooseRankingSetting] = useState<Shop>();
  const [listShopStarDamAfterSearch, setListShopStarDamAfterSearch] = useState<Array<Shop>>([]);
  const [searchShopInput, setSearchShopInput] = useState<string>('');
  const [rankingGroupShopSelectedItems, setRankingGroupShopSelectedItems] = useState<
    Array<SliderItem>
  >([]);

  const stardamGroupShops = useMemo(
    () => listShop.filter((item) => item.group_shop === 1),
    [listShop]
  );

  if (isMaster) {
    modalSettingProgramTabs.splice(1, 0, { title: t('GROUP_RANKING'), tab: 1.1 });
  }

  // maybe its profit or nomination
  const currentItemRankingType = useMemo(
    () => tempSelectedItemsTab.find((item) => item.order_by_ranking_id === itemRanking?.id),
    [tempSelectedItemsTab, itemRanking]
  );

  const mediaUrlLink = (url: string, typeImage: string) => {
    return `${IMAGE_BASE_URL}/${typeImage}/${url}`;
  };

  // const buildSliderItem = (
  //   item: any,
  //   tab: number,
  //   t: (key: string) => string,
  //   ranking_list_shop?: Array<{ select_shop_id?: number; id?: number }>
  // ): SliderItem => {
  //   const defaultNoteStyle = {
  //     font: 'NotoSansNormal',
  //     font_size: 20,
  //     color: '#FEC84B',
  //     stroke_color: '#ffffff',
  //     stroke_width: 2,
  //   };

  //   // update group ranking thì bỏ id
  //   return {
  //     ...item,

  //     ...(tab !== 1 && tab !== 1.1 && { isNewMedia: true }),
  //     ...(isMaster && tab !== 1.1 && { select_shop_id: selectShopOnChooseRankingSetting?.id }),
  //     ...(isMaster && tab === 1.1 && { ranking_list_shop, is_group_ranking: true }),

  //     created_at: item.created_at,
  //     updated_at: item.updated_at,

  //     images_slider_id: item.link ? item.id : null,
  //     images_slider: item.link ? item : null,

  //     order_by: item.order_by,
  //     order_by_ranking_id: item.name ? item.id : null,
  //     order_by_ranking: item.name ? (item as unknown as OrderByRankingItem) : null,

  //     second_change: 30,
  //     shop_id: item.shop_id,
  //     type: item.link ? 2 : 1,
  //     layout_ranking: 1,

  //     note_beside: item.name ? t(item.name) : null,
  //     font_beside: defaultNoteStyle.font,
  //     font_size_beside: defaultNoteStyle.font_size,
  //     color_beside: defaultNoteStyle.color,
  //     stroke_color_beside: defaultNoteStyle.stroke_color,
  //     stroke_width_beside: defaultNoteStyle.stroke_width,

  //     note_slider: item.name ? t(item.name) : null,
  //     font_slider: defaultNoteStyle.font,
  //     font_size_slider: defaultNoteStyle.font_size,
  //     color_slider: defaultNoteStyle.color,
  //     stroke_color_slider: defaultNoteStyle.stroke_color,
  //     stroke_width_slider: defaultNoteStyle.stroke_width,
  //   };
  // };
  const buildSliderItem = (
    item: any,
    tab: number,
    t: (key: string) => string,
    ranking_list_shop?: Array<{ select_shop_id?: number; id?: number }>
  ): SliderItem => {
    const defaultNoteStyle = {
      font: 'NotoSansNormal',
      font_size: 20,
      color: '#FEC84B',
      stroke_color: '#ffffff',
      stroke_width: 2,
    };
    // update group ranking thì bỏ id
    const result: SliderItem = {
      ...item,
      created_at: item.created_at,
      updated_at: item.updated_at,

      images_slider_id: item.link ? item.id : null,
      images_slider: item.link ? item : null,

      order_by: item.order_by,
      order_by_ranking_id: item.name ? item.id : null,
      order_by_ranking: item.name ? (item as unknown as OrderByRankingItem) : null,

      second_change: 30,
      shop_id: item.shop_id,
      type: item.link ? 2 : 1,
      layout_ranking: 1,

      note_beside: item.name ? t(item.name) : null,
      font_beside: defaultNoteStyle.font,
      font_size_beside: defaultNoteStyle.font_size,
      color_beside: defaultNoteStyle.color,
      stroke_color_beside: defaultNoteStyle.stroke_color,
      stroke_width_beside: defaultNoteStyle.stroke_width,

      note_slider: item.name ? t(item.name) : null,
      font_slider: defaultNoteStyle.font,
      font_size_slider: defaultNoteStyle.font_size,
      color_slider: defaultNoteStyle.color,
      stroke_color_slider: defaultNoteStyle.stroke_color,
      stroke_width_slider: defaultNoteStyle.stroke_width,
    };

    if (tab !== 1 && tab !== 1.1) {
      result.isNewMedia = true;
    } else {
      result.isNewRankingOfShopMaster = true;
    }

    if (isMaster && tab !== 1.1) {
      result.select_shop_id = selectShopOnChooseRankingSetting?.id;
    }

    if (isMaster && tab === 1.1) {
      result.ranking_list_shop = ranking_list_shop;
      result.is_group_ranking = true;
    }

    return result;
  };

  // const handleSelectMedia = (item: any) => {
  //   setSelectedSlideMedia((prev: any[]) => {
  //     const exists = prev.some((x) => x.id === item.id);
  //     if (exists) {
  //       return prev.filter((x) => x.id !== item.id);
  //     }
  //     return [...prev, item];
  //   });
  // };
  const handleSelectMedia = (item: any) => {
    setSelectedSlideMedia((prev: Array<SliderItem>) => {
      const exists = prev.some((x) => x.id === item.id);

      if (exists) {
        return prev.filter((x) => x.id !== item.id);
      }

      const newItem = buildSliderItem(item, tab, t);
      return [...prev, newItem];
    });
  };

  const toggleTempSelectTab = (item: any) => {
    setTempSelectedItemsTab((prev: Array<SliderItem>) => {
      if (![1].includes(tab)) return prev;

      const isSameItem = (i: any) => {
        // Ranking
        return (
          i.order_by_ranking_id === item.id &&
          i.select_shop_id === selectShopOnChooseRankingSetting?.id
        );
      };

      const exists = prev.some((i) => isSameItem(i));

      if (exists) {
        return prev.filter((i) => !isSameItem(i));
      }

      const newItem = buildSliderItem(item, tab, t);

      return [...prev, newItem];
    });
  };

  const handleAddRankingGroupShop = (item: any) => {
    setRankingGroupShopSelectedItems((prev: Array<SliderItem>) => {
      if (![1.1].includes(tab)) return prev;

      const isSameItem = (i: any) => {
        return i.order_by_ranking_id === item.id && i.is_group_ranking;
      };

      const exists = prev.some((i) => isSameItem(i));

      if (exists) {
        return prev.filter((i) => !isSameItem(i));
      }
      // const filteredGroupShopRanking = prev.filter(
      //   (shop) =>
      //     shop.is_group_ranking &&
      //     Array.isArray(shop.ranking_list_shop) &&
      //     shop.ranking_list_shop.length > 0
      // );
      // const rankingListShop = Array.from(
      //   new Map(
      //     [
      //       ...(rankingGroupShopSelected ?? []).map((item) => ({
      //         select_shop_id: item,
      //       })),
      //       ...(filteredGroupShopRanking[0]?.ranking_list_shop ?? []).map((item) => ({
      //         select_shop_id: item.select_shop_id,
      //       })),
      //     ].map((item) => [item.select_shop_id, item])
      //   ).values()
      // );

      // const newItem = buildSliderItem(item, tab, t, rankingListShop);
      const newItem = buildSliderItem(item, tab, t, []);
      const { id, select_shop, select_shop_id, ...rest } = newItem;
      return [...prev, rest];
    });
  };

  const dataTab = Array.isArray(data)
    ? data.filter((x: any) => {
        const link = x?.link || '';
        const hasPermission = x?.permissions_staff_creator?.length > 0;

        // TAB IMAGE
        if (tab === 2) {
          const isImage = !link.endsWith('.mp4');
          if (!isImage) return false;
          if (isMaster) return hasPermission;
          return true;
        }

        // TAB VIDEO
        if (tab === 3) {
          const isVideo = link.endsWith('.mp4');
          if (!isVideo) return false;

          if (isMaster) return hasPermission;

          return true;
        }
        return true;
      })
    : [];

  const settingRankingDataTypeTab = dataTab1
    .filter((x: any) => x.name !== 'PROFIT' && x.name !== 'NOMINATION')
    .sort((a: any, b: any) => {
      const aIsDay = a.name.includes('DAY');
      const bIsDay = b.name.includes('DAY');

      if (aIsDay === bIsDay) return 0;

      return aIsDay ? -1 : 1;
    });

  // can be replace this for future maintainable
  // const datatab1 = dataTab1.filter((x: any) => !['PROFIT', 'NOMINATION'].includes(x.name));

  const handleCheckProgramSelectedLayout = useCallback(
    (layout: 0 | 1) => {
      if (!itemRanking) return false;

      const selected = tempSelectedItemsTab.find((x: any) => {
        const checkRankingId = x?.order_by_ranking_id === itemRanking.id;
        const checkShopId = isMaster
          ? x?.select_shop_id === itemRanking.shop_id
          : x?.shop_id === itemRanking.shop_id;

        return checkRankingId && checkShopId;
      });

      const currentLayout = selected?.layout_ranking ?? 1;
      return currentLayout === layout;
    },
    [itemRanking, tempSelectedItemsTab, isMaster]
  );

  const handleToggleProgramLayout = (layout: 0 | 1) => {
    setTempSelectedItemsTab((prev: Array<SliderItem>) => {
      const index = prev.findIndex((x) =>
        isMaster
          ? x?.order_by_ranking_id === itemRanking?.id && x.select_shop_id === itemRanking?.shop_id
          : x?.order_by_ranking_id === itemRanking?.id
      );
      if (index === -1) return prev;

      const newArr = [...prev];
      newArr[index] = { ...newArr[index], layout_ranking: layout };
      return newArr;
    });
  };

  // handle search shop in tab 1.1
  const handleSearchShopChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchShopInput(value);
  };
  const handleDebounceSearchShopChange = useDebounceFn(handleSearchShopChange, 500);
  // console.log('settingRankingDataTypeTab: ', settingRankingDataTypeTab);
  // console.log('tempSelectedItemsTab: ', tempSelectedItemsTab);
  const __renderSelectProgramByTab = () => {
    switch (tab) {
      case 1:
        return (
          <>
            {isMaster && (
              <div className="flex overflow-x-auto overflow-y-hidden items-center">
                {stardamGroupShops.map((item) => {
                  const currentSelectShop = selectShopOnChooseRankingSetting?.id === item.id;

                  return (
                    <div className="border-b border-border-gray">
                      <Tooltip
                        title={item?.name}
                        placement="top"
                        overlayClassName="no-padding-bottom-tooltip"
                      >
                        <button
                          onClick={() => {
                            setSelectShopOnChooseRankingSetting(item);
                          }}
                          className={`flex items-center justify-center pt-3 pb-2 px-4 border-b-4 border-solid ${
                            currentSelectShop ? 'bg-primary-100 border-b-primary' : 'border-b-white'
                          }`}
                          key={item.id}
                        >
                          <img
                            src={item.avatar_image ? generateImage(item.avatar_image) : ShopNoLogo}
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.src = ShopNoLogo;
                            }}
                            alt={item.name}
                            className="rounded-lg min-w-[70px] h-[35px] border border-solid border-border-gray object-cover"
                            // className="rounded-lg min-w-[50px] h-8 border border-solid border-border-gray object-cover"
                          />
                        </button>
                      </Tooltip>
                    </div>
                  );
                })}
              </div>
            )}
            <div className="flex flex-col gap-3 px-4 py-3">
              {settingRankingDataTypeTab?.map((item: any) => {
                const isSelected = tempSelectedItemsTab.some((tempItem) => {
                  if (isMaster) {
                    return (
                      tempItem.order_by_ranking_id === item.id &&
                      tempItem.select_shop_id == selectShopOnChooseRankingSetting?.id
                    );
                  }
                  return tempItem.order_by_ranking_id === item.id;
                });

                const layoutAtRankingSettingIndex = tempSelectedItemsTab.findIndex((tempItem) => {
                  if (isMaster) {
                    return (
                      tempItem?.order_by_ranking_id === item?.id &&
                      tempItem.select_shop_id == selectShopOnChooseRankingSetting?.id
                    );
                  }
                  return tempItem?.order_by_ranking_id === item?.id;
                });
                return (
                  <button
                    key={item.id}
                    onClick={() => {
                      toggleTempSelectTab(item);
                    }}
                    // disabled={
                    //   isMaster &&
                    //   tempSelectedItemsTab.some((tempItem) => {
                    //     return tempItem.select_shop_id === selectShopOnChooseRankingSetting?.id;
                    //   })
                    // }
                    className={`${
                      isSelected ? 'border-[#2E90FA]' : 'border-border-gray'
                    } h-[60px] rounded-lg px-4 flex items-center justify-between border-solid border w-full`}
                  >
                    <div className="flex items-center">
                      <span className="mr-3 w-6 h-6">{isSelected && cts.checkIcon1}</span>
                      <span className="text-base text-[#333333] notosans_normal">
                        {t(item?.name)}
                        {layoutAtRankingSettingIndex !== -1 &&
                        tempSelectedItemsTab[layoutAtRankingSettingIndex].layout_ranking !== 1
                          ? '（一覧）'
                          : '（個人）'}
                      </span>
                    </div>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (isSelected) {
                          setItemRanking({
                            ...item,
                            shop_id: selectShopOnChooseRankingSetting?.id || selectShop.id,
                          });
                          setOpenChooseLayout(true);
                        }
                      }}
                      disabled={!isSelected}
                      className={!isSelected ? 'opacity-50 cursor-not-allowed' : ''}
                    >
                      {cts.iconLayout}
                    </button>
                  </button>
                );
              })}
            </div>
          </>
        );
      case 1.1:
        const handleSelectShopForRankingGroup = (shop: Shop) => {
          // create new ranking item for group ranking shop
          setRankingGroupShopSelectedItems((prev: Array<SliderItem>) => {
            if (tab !== 1.1) return prev;
            const allListsAreEmpty = prev
              .filter((item) => item.is_group_ranking)
              .every((item) => (item.ranking_list_shop ?? []).length === 0);

            return prev.map((item) => {
              if (!item.is_group_ranking) return item;
              const currentList = item.ranking_list_shop ?? [];
              const deletedShopIdsList = item.delete_ranking_list_shop_ids ?? [];
              const isSameItem = (checkItem: any) => checkItem.select_shop_id === shop.id;

              const matchedItem = currentList.some((i) => isSameItem(i));
              if (matchedItem) {
                const updatedList = currentList.filter((i) => !isSameItem(i));
                const indexShopGroupRankingDelete = currentList.findIndex(
                  (shopItemInRankingGroup) => shopItemInRankingGroup.select_shop_id === shop.id
                );
                if (indexShopGroupRankingDelete !== -1) {
                  const shopGroupRankingNeedToDeleted = currentList[indexShopGroupRankingDelete];
                  if (shopGroupRankingNeedToDeleted.select_shop_id) {
                    return {
                      ...item,
                      ranking_list_shop: updatedList,
                      delete_ranking_list_shop_ids: [
                        ...deletedShopIdsList,
                        shopGroupRankingNeedToDeleted.select_shop_id!,
                      ],
                    };
                  }
                }
              } else {
                if (currentList.length === 0 && !allListsAreEmpty) {
                  return item;
                }
              }
              return {
                ...item,
                ranking_list_shop: [...currentList, { select_shop_id: shop.id }],
              };
            });
          });
        };

        const hasGroupRankingDetail = rankingGroupShopSelectedItems.some(
          (item) => item.is_group_ranking
        );
        const mid = Math.ceil(listShopStarDamAfterSearch.length / 2);

        const leftColumn = listShopStarDamAfterSearch.slice(0, mid);
        const rightColumn = listShopStarDamAfterSearch.slice(mid);
        return (
          <div className="px-4 py-3 space-y-3">
            <div className="grid grid-cols-2 gap-3">
              {settingRankingDataTypeTab?.map((item: any) => {
                const isSelected = rankingGroupShopSelectedItems.some((tempItem) => {
                  if (isMaster) {
                    return tempItem.order_by_ranking_id === item.id && tempItem.is_group_ranking;
                  }
                  return tempItem.order_by_ranking_id === item.id;
                });
                const isSelectedRankingGroupType =
                  rankingGroupShopSelectedItems.length === 1 &&
                  rankingGroupShopSelectedItems[0]?.name !== item?.name;
                return (
                  <button
                    key={item.id}
                    onClick={() => {
                      handleAddRankingGroupShop(item);
                    }}
                    disabled={isSelectedRankingGroupType}
                    className={`${isSelected ? 'border-[#2E90FA]' : 'border-border-gray'} ${
                      isSelectedRankingGroupType ? 'bg-gray-200 cursor-not-allowed' : ''
                    } h-[60px] rounded-lg px-4 flex items-center justify-between border-solid border w-full`}
                  >
                    <div className="flex items-center">
                      <span className="mr-3 w-6 h-6">{isSelected && cts.checkIcon1}</span>
                      <span className="text-base text-[#333333] notosans_normal">
                        {t(item?.name)}
                      </span>
                    </div>
                  </button>
                );
              })}
            </div>
            <div className="w-full border-t border-border-gray">
              <div className="flex items-center my-3 w-full h-10 rounded-md">
                <div className="flex gap-2 items-center px-3 w-full h-full rounded-l-lg border border-border-gray">
                  <span>{cts.searchShopSmallIcon}</span>
                  <input
                    type="text"
                    className="w-full h-full border border-none outline-none"
                    placeholder={t('SEARCH_SHOP')}
                    onChange={handleDebounceSearchShopChange}
                  />
                </div>
                <button
                  onClick={() => setSearchShopInput(searchShopInput || '')}
                  className="block px-4 h-full text-white whitespace-nowrap rounded-r-md hover:bg-primary/90 font-notosans-400 bg-primary"
                >
                  {t('SEARCH')}
                </button>
              </div>
              {listShopStarDamAfterSearch.length > 0 ? (
                <div className="flex gap-3 overflow-auto max-h-[334px]">
                  {/* LEFT COLUMN */}
                  <div className="flex flex-col gap-2 w-1/2">
                    {leftColumn.map((shop) => {
                      const rankingGroupShopSelected = (shopId: number) => {
                        const filterGroupShopRankingItem = rankingGroupShopSelectedItems.filter(
                          (item) => item.is_group_ranking
                        );
                        return filterGroupShopRankingItem.some((item) =>
                          item.ranking_list_shop?.some(
                            (rankingShopGroupItem) => rankingShopGroupItem.select_shop_id === shopId
                          )
                        );
                      };
                      return (
                        <button
                          disabled={!hasGroupRankingDetail}
                          onClick={() => handleSelectShopForRankingGroup(shop)}
                          key={shop.id}
                          className={`flex items-center justify-between w-full px-3 py-2 border border-solid rounded-lg h-fit border-border-gray
                          ${rankingGroupShopSelected(shop.id) && '!border-[#2E90FA]'}
                          ${!hasGroupRankingDetail && 'cursor-not-allowed bg-gray-200'}`}
                        >
                          <div className="flex gap-3 items-center">
                            <img
                              src={
                                shop.avatar_image && (shop?.avatar_image ?? '')
                                  ? generateImage(shop?.avatar_image)
                                  : ShopNoLogo
                              }
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = ShopNoLogo;
                              }}
                              alt=""
                              className="rounded-lg min-w-[45px] h-[30px] border border-solid border-border-gray object-cover"
                            />
                            <p className="text-sm line-clamp-1 font-notosans-400">{shop.name}</p>
                          </div>
                          <span>{rankingGroupShopSelected(shop.id) && cts.checkIcon1}</span>
                        </button>
                      );
                    })}
                  </div>

                  {/* RIGHT COLUMN */}
                  <div className="flex flex-col gap-2 w-1/2">
                    {rightColumn.map((shop) => {
                      const rankingGroupShopSelected = (shopId: number) => {
                        const filterGroupShopRankingItem = rankingGroupShopSelectedItems.filter(
                          (item) => item.is_group_ranking
                        );
                        return filterGroupShopRankingItem.some((item) =>
                          item.ranking_list_shop?.some(
                            (rankingShopGroupItem) => rankingShopGroupItem.select_shop_id === shopId
                          )
                        );
                      };
                      return (
                        <button
                          disabled={!hasGroupRankingDetail}
                          onClick={() => handleSelectShopForRankingGroup(shop)}
                          key={shop.id}
                          className={`flex items-center justify-between w-full px-3 py-2 border border-solid rounded-lg h-fit border-border-gray
                          ${rankingGroupShopSelected(shop.id) && '!border-[#2E90FA]'}
                          ${!hasGroupRankingDetail && 'cursor-not-allowed bg-gray-200'}`}
                        >
                          <div className="flex gap-3 items-center">
                            <img
                              src={
                                shop.avatar_image && (shop?.avatar_image ?? '')
                                  ? generateImage(shop?.avatar_image)
                                  : ShopNoLogo
                              }
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = ShopNoLogo;
                              }}
                              alt=""
                              className="rounded-lg min-w-[45px] h-[30px] border border-solid border-border-gray object-cover"
                            />
                            <p className="text-sm line-clamp-1 font-notosans-400">{shop.name}</p>
                          </div>
                          <span>{rankingGroupShopSelected(shop.id) && cts.checkIcon1}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div className="flex justify-center items-center py-10 w-full">
                  <Empty description={t('NO_DATA')} />
                </div>
              )}
            </div>
          </div>
        );
      case 2:
        return (
          <>
            <div className="grid w-full h-full grid-cols-5 gap-3 px-4 py-3 max-h-[345px] overflow-auto">
              {/* Select image at tab 2 and video at tab 3 */}
              {dataTab?.map((x: any, y: number) => {
                const isSelected = selectedSlideMedia.some((i: any) => i.id === x.id);
                return (
                  <button
                    key={y}
                    className={`border-[2px] border-solid rounded-lg ${
                      isSelected ? ' border-[#2E90FA]' : ' border-white'
                    } relative`}
                    onClick={() => {
                      handleSelectMedia(x);
                      toggleTempSelectTab(x);
                    }}
                  >
                    <img
                      src={x.imageUrl || mediaUrlLink(x?.link, 'images_slider')}
                      className="h-[150px] w-[150px] rounded-md object-cover"
                    />

                    <div
                      className={`absolute bottom-1 right-1 w-6 h-6 rounded-full ${
                        !isSelected && 'bg-white'
                      }`}
                    >
                      {isSelected && <>{cts.checkRadio}</>}
                    </div>
                  </button>
                );
              })}
            </div>
          </>
        );
      case 3:
        return (
          <div className="grid w-full h-full grid-cols-5 gap-3 px-4 py-3 max-h-[345px] overflow-auto">
            {/* Select image at tab 2 and video at tab 3 */}
            {dataTab?.map((x: any, y: number) => {
              const isSelected = selectedSlideMedia.some((i: any) => i.id === x.id);
              return (
                <button
                  key={y}
                  className={`border-[2px] border-solid rounded-lg ${
                    isSelected ? ' border-[#2E90FA]' : ' border-white'
                  } relative`}
                  onClick={() => {
                    handleSelectMedia(x);
                    toggleTempSelectTab(x);
                  }}
                >
                  <video
                    src={x.imageUrl || mediaUrlLink(x?.link, 'images_slider')}
                    className="h-[150px] w-[150px] rounded-md object-cover"
                    autoPlay
                    loop
                    muted
                  />

                  <div
                    className={`absolute bottom-1 right-1 w-6 h-6 rounded-full ${
                      !isSelected && 'bg-white'
                    }`}
                  >
                    {isSelected && <>{cts.checkRadio}</>}
                  </div>
                </button>
              );
            })}
          </div>
        );
      default:
        return <></>;
    }
  };

  // type RankingDisplay = 'onlyTop10' | 'otherThan10';
  // 0 & null: onlyTop10, 1: otherThan10
  // layout_ranking: 0 & 1
  // 0: layout slide 10 person/slide
  // 1: layout carousel 1 person/slide
  const __renderDisplayRankingType = () => {
    const checkRankingDisplay = (type: RankingDisplay) => {
      const normalizedType = type ?? 0;
      const normalizedCurrent = currentItemRankingType?.layout_quantity_user_slider_ranking ?? 0;

      return normalizedCurrent === normalizedType
        ? 'border border-solid border-primary text-primary bg-brand_50 font-notosans-700 justify-between'
        : 'bg-gray_100 font-notosans-400 justify-center';
    };

    const updateRankingItem = (updater: (item: SliderItem) => SliderItem) => {
      setTempSelectedItemsTab((prev) => {
        const index = prev.findIndex((x) => x?.order_by_ranking_id === itemRanking?.id);
        if (index === -1) return prev;

        const next = [...prev];
        next[index] = updater(next[index]);
        return next;
      });
    };
    const handleSelectRankingDisplay = (type: RankingDisplay) => {
      // auto set layout_ranking to 1 to default when switching between ranking display type
      handleToggleProgramLayout(1);

      // update layout_quantity_user_slider_ranking
      const layoutValue = type ? 1 : 0;
      updateRankingItem((item) => ({
        ...item,
        layout_quantity_user_slider_ranking: layoutValue,
      }));
    };

    const handleChangeQuantity = (value: number) => {
      updateRankingItem((item) => ({
        ...item,
        quantity_user_slider_app_rank: value || '',
      }));
    };

    const isAllowMoreThan10PersonMode =
      currentItemRankingType?.layout_quantity_user_slider_ranking === 1;
    return (
      <>
        {/* Select layout type (from 1 to 10, over 10 person) */}
        <div className="py-4 mx-4 border-b border-border-gray">
          <span className="font-notosans-700">{t('RANKING_DISPLAY')}</span>
          <div className="flex gap-3 mt-2 w-full">
            <button
              onClick={() => handleSelectRankingDisplay(0)}
              className={`flex items-center px-3 w-1/2 rounded-lg transition-all py-[10px] ${checkRankingDisplay(0)}`}
            >
              {!isAllowMoreThan10PersonMode && <div className="size-5"></div>}
              {t('SHOW_ONLY_TOP_10')}
              {!isAllowMoreThan10PersonMode && <span>{cts.checkIcon}</span>}
            </button>
            <button
              onClick={() => handleSelectRankingDisplay(1)}
              className={`flex items-center px-3 w-1/2 rounded-lg transition-all py-[10px] ${checkRankingDisplay(1)}`}
            >
              {isAllowMoreThan10PersonMode && <div className="size-5"></div>}
              {t('DISPLAY_OTHER_THAN_10')}
              {isAllowMoreThan10PersonMode && <span>{cts.checkIcon}</span>}
            </button>
            {isAllowMoreThan10PersonMode && (
              <Input
                suffix={'人'}
                onChange={(e) => handleChangeQuantity(Number(e.target.value))}
                value={currentItemRankingType.quantity_user_slider_app_rank}
                className="w-20 px-2 text-center border border-solid rounded-lg !outline-none border-border-gray"
                placeholder="人数"
                type="number"
              />
            )}
          </div>
        </div>
      </>
    );
  };

  useEffect(() => {
    // if (open) {
    //   setTempSelectedItemsTab(imageSliderState);
    // }
    return () => {
      setTempSelectedItemsTab([]);
      setRankingGroupShopSelectedItems([]);
    };
  }, [open]);

  useEffect(() => {
    if (stardamGroupShops.length > 0) {
      setListShopStarDamAfterSearch(
        stardamGroupShops?.sort((a, b) => a.name.localeCompare(b.name))
      );
    }
  }, [stardamGroupShops]);

  useEffect(() => {
    if (searchShopInput !== '') {
      const searchKeyLowerCase = searchShopInput.toLocaleLowerCase();
      const resultAfterSearchFilter = listShopStarDamAfterSearch
        .filter((item: Shop) => {
          return (
            searchKeyLowerCase.includes(item?.name.toLowerCase()) ||
            item?.name.toLowerCase().includes(searchKeyLowerCase)
          );
        })
        .sort((a, b) => a.name.localeCompare(b.name));
      setListShopStarDamAfterSearch(resultAfterSearchFilter);
    } else {
      setListShopStarDamAfterSearch(
        stardamGroupShops?.sort((a, b) => a.name.localeCompare(b.name))
      );
    }
  }, [searchShopInput, listShop.length]);

  // auto set layout_ranking: 0
  useEffect(() => {
    if (openChooseLayout && itemRanking) {
      setTempSelectedItemsTab((prev: Array<SliderItem>) => {
        const index = prev.findIndex((x) => x?.order_by_ranking_id === itemRanking?.id);
        if (index === -1) return prev;

        const currentItem = prev[index];
        // If doesn't have layout_ranking (null or undefined), set default 0
        if (currentItem.layout_ranking === null || currentItem.layout_ranking === undefined) {
          const newArr = [...prev];
          newArr[index] = { ...newArr[index], layout_ranking: 0 };
          return newArr;
        }
        return prev;
      });
    }
  }, [openChooseLayout, itemRanking]);

  useEffect(() => {
    if (stardamGroupShops && stardamGroupShops.length > 0 && isMaster) {
      setSelectShopOnChooseRankingSetting(stardamGroupShops[0]);
    }
  }, [stardamGroupShops, isMaster]);

  return (
    <Modal
      centered
      visible={open}
      onOk={() => setOpen(false)}
      onCancel={() => setOpen(false)}
      className="modal_select_still"
    >
      <div className="flex flex-col">
        <div className="flex justify-between items-center px-4 h-14 border-b border-solid border-border-gray">
          {/* modal header */}
          <span className="text-[#1D2939] text-xl font-notosans-700">{t('LIST_IMAGE_VIDEO')}</span>
          <button
            onClick={() => {
              setOpen(false);
            }}
            className="text-base text-primary font-notosans-700"
          >
            {t('CLOSE')}
          </button>
        </div>

        {/* modal select tab */}
        <div
          className={`grid h-[50px] border-solid border-border-gray border-b ${isMaster ? 'grid-cols-4' : 'grid-cols-3'}`}
        >
          {modalSettingProgramTabs.map((item) => (
            <button
              key={item.tab}
              onClick={() => setTab(item.tab)}
              className={`${
                tab === item.tab
                  ? 'font-notosans-700 text-primary border-solid border-primary border-b-[3px]'
                  : 'font-notosans-400 text-[#939393]'
              } h-full flex items-center justify-center text-base`}
            >
              {item.title}
            </button>
          ))}
        </div>
        {/* modal data by tab */}
        {/* old layout, delete hidden to get back */}
        <div className={`hidden overflow-y-auto w-full h-fit max-h-[423px]`}>
          {tab === 1 ? (
            <>
              {isMaster ? (
                <div className="flex overflow-x-auto overflow-y-hidden items-center">
                  {stardamGroupShops.map((item) => {
                    const currentSelectShop = selectShopOnChooseRankingSetting?.id === item.id;

                    return (
                      <div className="border-b border-border-gray">
                        <Tooltip
                          title={item?.name}
                          placement="top"
                          overlayClassName="no-padding-bottom-tooltip"
                        >
                          <button
                            onClick={() => {
                              setSelectShopOnChooseRankingSetting(item);
                            }}
                            className={`flex items-center justify-center pt-3 pb-2 px-4 border-b-4 border-solid ${
                              currentSelectShop
                                ? 'bg-primary-100 border-b-primary'
                                : 'border-b-white'
                            }`}
                            key={item.id}
                          >
                            <img
                              src={
                                item.avatar_image ? generateImage(item.avatar_image) : ShopNoLogo
                              }
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = ShopNoLogo;
                              }}
                              alt={item.name}
                              className="rounded-lg min-w-[70px] h-[35px] border border-solid border-border-gray object-cover"
                              // className="rounded-lg min-w-[50px] h-8 border border-solid border-border-gray object-cover"
                            />
                          </button>
                        </Tooltip>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <></>
              )}

              <div className="flex flex-col gap-3 px-4 py-3">
                {settingRankingDataTypeTab?.map((item: any) => {
                  // const isSelected = tempSelectedItemsTab.some(
                  //   (i) => i.order_by_ranking_id === x.id
                  // );
                  const currentSelectShop = selectShopOnChooseRankingSetting?.id === item.id;
                  const isSelected = tempSelectedItemsTab.some((tempItem) => {
                    if (isMaster) {
                      return (
                        tempItem.order_by_ranking_id === item.id &&
                        tempItem.select_shop_id == selectShopOnChooseRankingSetting?.id
                      );
                    }
                    return tempItem.order_by_ranking_id === item.id;
                  });

                  const layoutAtRankingSettingIndex = tempSelectedItemsTab.findIndex((tempItem) => {
                    if (isMaster) {
                      return (
                        tempItem?.order_by_ranking_id === item?.id &&
                        tempItem.select_shop_id == selectShopOnChooseRankingSetting?.id
                      );
                    }
                    return tempItem?.order_by_ranking_id === item?.id;
                  });
                  return (
                    <button
                      // disabled={isMaster == true}
                      key={item.id}
                      onClick={() => {
                        toggleTempSelectTab(item);
                      }}
                      className={`${
                        isSelected ? 'border-[#2E90FA]' : 'border-border-gray'
                      } h-[60px] rounded-lg px-4 flex items-center justify-between border-solid border w-full`}
                    >
                      <div className="flex items-center">
                        <span className="mr-3 w-6 h-6">{isSelected && cts.checkIcon1}</span>
                        <span className="text-base text-[#333333] notosans_normal">
                          {t(item?.name)}

                          {/* {tempSelectedItemsTab.find(
                            (item: any) => item?.order_by_ranking_id === item?.id
                          )?.layout_ranking === 1
                            ? '（個人）'
                            : '（一覧）'} */}
                          {layoutAtRankingSettingIndex !== -1 &&
                          tempSelectedItemsTab[layoutAtRankingSettingIndex].layout_ranking !== 1
                            ? '（一覧）'
                            : '（個人）'}
                        </span>
                      </div>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (isSelected) {
                            setItemRanking({
                              ...item,
                              shop_id: selectShopOnChooseRankingSetting?.id || selectShop.id,
                            });
                            setOpenChooseLayout(true);
                          }
                        }}
                        disabled={!isSelected}
                        className={!isSelected ? 'opacity-50 cursor-not-allowed' : ''}
                      >
                        {cts.iconLayout}
                      </button>
                    </button>
                  );
                })}
              </div>
            </>
          ) : (
            <div className="grid w-full h-full grid-cols-5 gap-3 px-4 py-3 max-h-[345px] overflow-auto">
              {/* Select image at tab 2 and video at tab 3 */}
              {dataTab?.map((x: any, y: number) => {
                const isSelected = selectedSlideMedia.some((i: any) => i.id === x.id);
                return (
                  <button
                    key={y}
                    className={`border-[2px] border-solid rounded-lg ${
                      isSelected ? ' border-[#2E90FA]' : ' border-white'
                    } relative`}
                    onClick={() => {
                      handleSelectMedia(x);
                      toggleTempSelectTab(x);
                    }}
                  >
                    {tab !== 2 ? (
                      <video
                        src={x.imageUrl || mediaUrlLink(x?.link, 'images_slider')}
                        className="h-[150px] w-[150px] rounded-md object-cover"
                        autoPlay
                        loop
                        muted
                      />
                    ) : (
                      <img
                        src={x.imageUrl || mediaUrlLink(x?.link, 'images_slider')}
                        className="h-[150px] w-[150px] rounded-md object-cover"
                      />
                    )}

                    <div
                      className={`absolute bottom-1 right-1 w-6 h-6 rounded-full ${
                        !isSelected && 'bg-white'
                      }`}
                    >
                      {isSelected && <>{cts.checkRadio}</>}
                    </div>
                  </button>
                );
              })}
            </div>
          )}
        </div>
        {__renderSelectProgramByTab()}
        <div className="p-3 border-t border-solid border-border-gray">
          <button
            onClick={() => {
              setImageSliderState((prev: any[]) => {
                const maxOrder = prev.reduce(
                  (max: number, item: any) => Math.max(max, item.order_by),
                  0
                );
                const newRankingGroupShopItems = rankingGroupShopSelectedItems.filter(
                  (item) => item.isNewRankingOfShopMaster
                );
                const newRankingAnotherShopItems = tempSelectedItemsTab.filter(
                  (item) => item.isNewRankingOfShopMaster
                );
                const rankingItems = [
                  ...imageSliderState,
                  ...newRankingGroupShopItems,
                  ...newRankingAnotherShopItems,
                ].map((item, index) => {
                  const defaultNote = item.order_by_ranking?.name
                    ? t(item.order_by_ranking.name)
                    : null;

                  return {
                    ...item,
                    order_by: maxOrder + index + 1,
                    program_rank_id: selectItem?.id,
                    note_beside: item.note_beside ?? defaultNote,
                    note_slider: item.note_slider ?? defaultNote,
                  };
                });

                const imageItems = selectedSlideMedia.map((item, index) => {
                  const defaultNote = item.order_by_ranking?.name
                    ? t(item.order_by_ranking.name)
                    : null;

                  return {
                    ...item,
                    order_by: maxOrder + rankingItems.length + index + 1,
                    program_rank_id: selectItem?.id,
                    note_beside: item.note_beside ?? defaultNote,
                    note_slider: item.note_slider ?? defaultNote,
                  };
                });

                return [...rankingItems, ...imageItems];
              });

              setOpen(false);
              setSelectedSlideMedia([]);
            }}
            className="flex justify-center items-center w-full h-11 rounded-lg bg-primary"
          >
            <span className="ml-2 text-base text-white notosans_medium">{t('SELECT')}</span>
          </button>
        </div>
      </div>
      <Modal
        centered
        visible={openChooseLayout}
        onOk={() => setOpenChooseLayout(false)}
        onCancel={() => setOpenChooseLayout(false)}
        className="modal_review_img !w-[644px]"
      >
        <div className="flex flex-col">
          {/* MODAL CHOOSE LAYOUT HEADER */}
          <div className="flex justify-between items-center px-4 h-14 border-b border-solid border-border-gray">
            <span className="text-[#1D2939] text-xl notosans_bold">{t('LAYOUT')}</span>
            <button
              onClick={() => setOpenChooseLayout(false)}
              className="text-base notosans_medium text-primary"
            >
              {t('CLOSE')}
            </button>
          </div>

          {__renderDisplayRankingType()}

          {/* MODAL CHOOSE LAYOUT BODY */}
          <div className="flex gap-3 items-center p-4 border-b border-border-gray">
            <button
              onClick={() => handleToggleProgramLayout(1)}
              className={`${
                handleCheckProgramSelectedLayout(1)
                  ? 'bg-[#F9F5FF] border border-solid border-primary'
                  : 'border border-solid border-border-gray'
              } relative flex flex-col items-center justify-center rounded-lg p-3 w-1/2`}
            >
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  if (handleCheckProgramSelectedLayout(1)) {
                    setCurrentLayoutForEdit(1);
                    setIsOpenModalEditText(true);
                    setImagePreview(imgPreview2);
                  }
                }}
                className={`absolute right-2 top-0 mt-2 bg-white size-10 rounded-lg border border-solid border-primary flex items-center justify-center ${
                  handleCheckProgramSelectedLayout(1)
                    ? 'cursor-pointer'
                    : 'opacity-90 cursor-not-allowed pointer-events-none'
                }`}
              >
                {cts.editBtn}
              </span>
              <img src={slide} className="w-full" />
              <div className="flex gap-2 items-center">
                <span>{handleCheckProgramSelectedLayout(1) ? cts.checkActive : cts.check}</span>
                <span className="text-sm text-[#252B37] notosans_normal">{t('SLIDER')}</span>
              </div>
            </button>

            <button
              onClick={() => handleToggleProgramLayout(0)}
              disabled={currentItemRankingType?.layout_quantity_user_slider_ranking == 1}
              className={`${
                handleCheckProgramSelectedLayout(0)
                  ? 'bg-[#F9F5FF] border border-solid border-primary'
                  : 'border border-solid border-border-gray'
              } relative flex flex-col items-center justify-center rounded-lg p-3 w-1/2 ${currentItemRankingType?.layout_quantity_user_slider_ranking == 1 && 'cursor-not-allowed opacity-60 !bg-[#f5f5f5]'}`}
            >
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  if (handleCheckProgramSelectedLayout(0)) {
                    setCurrentLayoutForEdit(0);
                    setIsOpenModalEditText(true);
                    setImagePreview(imgPreview1);
                  }
                }}
                className={`absolute right-2 top-0 mt-2 bg-white size-10 rounded-lg border border-solid border-primary flex items-center justify-center ${
                  handleCheckProgramSelectedLayout(0)
                    ? 'cursor-pointer'
                    : 'opacity-90 cursor-not-allowed pointer-events-none'
                } ${currentItemRankingType?.layout_quantity_user_slider_ranking == 1 && '!bg-[#f5f5f5]'}`}
              >
                {cts.editBtn}
              </span>

              <img src={beside} className="w-full" />

              <div className="flex gap-2 items-center">
                <span>{handleCheckProgramSelectedLayout(0) ? cts.checkActive : cts.check}</span>
                <span className="text-sm text-[#252B37] notosans_normal">{t('BESIDE')}</span>
              </div>
            </button>
          </div>
          <div className="justify-center items-center p-4">
            <button
              onClick={() => {
                setOpenChooseLayout(false);
              }}
              className="w-full h-11 text-base text-white rounded-lg font-notosans-700 bg-primary"
            >
              {t('KEEP')}
            </button>
          </div>
        </div>
        {isOpenModalEditText && itemRanking && currentLayoutForEdit !== null && (
          <ModalTextEditor
            onClose={() => {
              setIsOpenModalEditText(false);
              setCurrentLayoutForEdit(null);
            }}
            initialNote={(() => {
              const currentItem = tempSelectedItemsTab.find(
                (x: any) => x?.order_by_ranking_id === itemRanking?.id
              );
              if (!currentItem) return t(itemRanking?.name ?? '');

              // Nếu currentLayoutForEdit null, dùng layout_ranking của item, default là 0
              const layoutForEdit = currentLayoutForEdit ?? currentItem.layout_ranking ?? 0;

              // Lấy note theo layout (0 = beside, 1 = slider)
              const note = layoutForEdit === 0 ? currentItem.note_beside : currentItem.note_slider;

              return note || t(itemRanking?.name ?? '');
            })()}
            initialStyleConfig={(() => {
              const currentItem = tempSelectedItemsTab.find(
                (x: any) => x?.order_by_ranking_id === itemRanking?.id
              );
              if (!currentItem) return undefined;

              // Nếu currentLayoutForEdit null, dùng layout_ranking của item, default là 0
              const layoutForEdit = currentLayoutForEdit ?? currentItem.layout_ranking ?? 0;

              // Lấy styleConfig theo layout (0 = beside, 1 = slider)
              if (layoutForEdit === 0) {
                return currentItem.font_beside
                  ? {
                      font: currentItem.font_beside,
                      font_size: currentItem.font_size_beside || 20,
                      color: currentItem.color_beside || '#FEC84B',
                      stroke_color: currentItem.stroke_color_beside || '#ffffff',
                      stroke_width: currentItem.stroke_width_beside || 2,
                    }
                  : undefined;
              } else {
                return currentItem.font_slider
                  ? {
                      font: currentItem.font_slider,
                      font_size: currentItem.font_size_slider || 20,
                      color: currentItem.color_slider || '#FEC84B',
                      stroke_color: currentItem.stroke_color_slider || '#ffffff',
                      stroke_width: currentItem.stroke_width_slider || 2,
                    }
                  : undefined;
              }
            })()}
            onSave={(data: { note: string; styleConfig: NoteStyleConfig }) => {
              // Lưu note vào local state (tempSelectedItemsTab) - lưu từng field riêng biệt
              setTempSelectedItemsTab((prev: Array<SliderItem>) => {
                const index = prev.findIndex((x) => x?.order_by_ranking_id === itemRanking?.id);
                if (index === -1) return prev;

                const newArr = [...prev];
                const currentItem = newArr[index];

                // Nếu layout_ranking null, set default là 0 (Beside)
                const layoutRanking = currentItem.layout_ranking ?? 0;
                const layoutForEdit = currentLayoutForEdit ?? layoutRanking;

                // Lưu note theo layout (0 = beside, 1 = slider)
                if (layoutForEdit === 0) {
                  newArr[index] = {
                    ...newArr[index],
                    layout_ranking: 0, // Đảm bảo layout_ranking có giá trị
                    note_beside: data.note,
                    font_beside: data.styleConfig.font,
                    font_size_beside: data.styleConfig.font_size,
                    color_beside: rgbToHex(data.styleConfig.color),
                    stroke_color_beside: data.styleConfig.stroke_color,
                    stroke_width_beside: data.styleConfig.stroke_width,
                  };
                } else {
                  newArr[index] = {
                    ...newArr[index],
                    layout_ranking: 1, // Đảm bảo layout_ranking có giá trị
                    note_slider: data.note,
                    font_slider: data.styleConfig.font,
                    font_size_slider: data.styleConfig.font_size,
                    color_slider: rgbToHex(data.styleConfig.color),
                    stroke_color_slider: data.styleConfig.stroke_color,
                    stroke_width_slider: data.styleConfig.stroke_width,
                  };
                }

                return newArr;
              });
              setIsOpenModalEditText(false);
              setCurrentLayoutForEdit(null);
            }}
            previewImage={imagePreview as string}
            isNote={false}
          />
        )}
      </Modal>
    </Modal>
  );
}
export default memo(ModalSelectItemProgram);
